const data_index_min = 0;
const data_index_max = 3;

export const data_index =
  Math.floor(Math.random() * (data_index_max + 1 - data_index_min)) +
  data_index_min;
